
export default {
  name: 'OrganismSidebarAccordion',
  props: {
    pinsInfo: [],
    sidebarTitle: {
      required: false,
      type: String,
      default: ''
    }
  },
  computed: {
    isMenuOpen() {
      return this.$store.state.base.isAvailabilityMenuOpen
    }
  }
}
